import React from "react";
import { stack as Menu } from "react-burger-menu";
import styled from "styled-components";
import { Dropdown } from "react-bootstrap";

const previousIssues = [
  {
    name: "Cities",
    link: "/bside/cities"
  }
];

const PreviousIssuesHeader = styled.div`
  color: #bdc3c7;
`;

const StyledPreviousIssue = styled.a`
  padding-left: 20px;
  text-decoration: none;
  color: white;
`;

const Burger = props => {
  return (
    <Menu className="right" right>
      <a id="home" className="menu-item" href="/bside/">
        Current Issue
      </a>
      <a id="about" className="menu-item" href="https://www.michigandaily.com/section/arts">
        Read more arts
      </a>
      {/* <PreviousIssuesHeader>Previous Issues:</PreviousIssuesHeader>
      {previousIssues.map((issue, i) => (
        <StyledPreviousIssue id={i} href={issue.link} className="previousIssue">
          - {issue.name}
        </StyledPreviousIssue>
      ))} */}
    </Menu>
  );
};
export default Burger;
